module.exports = __webpack_public_path__ + "static/media/pastelqueijo.3764df99.webp";